import Content from "./Content";

/**
 * PhonecallContent.js
 * 
 * Created on Oct 8, 2013, 4:43:46 PM
 *
 * @author Javier Quevedo-Fernandez for Ranj
 **/
export default class PhonecallContent extends Content {
    constructor(languagePack, contentID, npcID, dialogId, incoming, playerInitiated, label) {
        super(PhonecallContent.NAME, PhonecallContent.TYPE, label, languagePack, contentID);
        this._npcID = npcID;
        this._dialogID = dialogId;
        this._playerInitiated = playerInitiated;
        this._incoming = incoming;
    }

    remove() {
        this._npcID = null;
        this._dialogID = null;
        super.remove();
    }

    getDialogID() {
        return this._dialogID;
    }

    setDialogID(value) {
        this._dialogID = value;
    }

    getNpcID() {
        return this._npcID;
    }

    setNpcID(value) {
        this._npcID = value;
    }

    getIncoming() {
        return this._incoming;
    }

    setIncoming(value) {
        this._incoming = value;
    }

    getPlayerInitiated() {
        return this._playerInitiated;
    }

    setPlayerInitiated(value) {
        this._playerInitiated = value;
    }

    convertToObject() {
        return this.getObject(["npcID", "dialogID", "incoming", "playerInitiated"]);
    }
}

PhonecallContent.NAME = "Phonecall";
PhonecallContent.TYPE = "engPhonecallContent";
